<template>
  <div>
    <CRow>
      <CCol sm="12">
        <GlobalTable
          :title="'Serial Number'"
          :fields="fields"
          :items="data"
          :editButton="true"
          :redirectDetail="false"
          :enableAddButton="true"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{title}}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Serial Number"
              invalid-feedback="Serial number should be filled"
              required
              v-model="$v.freezeForm.serial_number.$model"
              :is-valid="!$v.freezeForm.serial_number.$invalid"
            />
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton @click="submitForm" :disabled="$v.freezeForm.$invalid" color="success">
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../../templates/Loading";
import GlobalTable from "../../../../templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "SerialNumber",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Serial Number",
      items: [],
      productPriceList: [],
      addButton: false,
      isEdit: false,
      freezeForm: tableInterfaces.freezer_serialnmb,
      isLoading: false,
      image: null,
      activeTab: 0,
      checkedFlag: "Agent",
      fields: [
        { key: "serial_number", label: "Serial Number", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      theid:'',
      freezer_code:null
    };
  },
  validations: {
    freezeForm: {
      serial_number: { required }
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function() {
      return (this.items.length > 0) ? this.items: this.freeze;
    }
  },
  methods: {
    init: function (id) {
      this.getSerialNumber(id);
      this.theid = id;
    },
    getSerialNumber: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/freezer_serialnumber/listing/"+id)
        .then((response) => {
        if (response.data.status === 2000) {
          // console.log(response.data)
          this.items = response.data.data;

          this.freezer_code = response.data.detail.freezer_code;
          
          this.showInfoNotification({
            title: this.title,
            message: response.data.message,
          });
        } else {
          this.showErrorNotification({
            title: this.title,
            message: response.data.message,
          });
        }
      })
      .catch((error) => {
        this.showErrorNotification({
          title: this.title,
          message: error,
        });
      })
      .finally(() => {
        this.isLoading = false;
        this.cancelForm();
      });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.freezeForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.freezer_serialnmb) {
        tableInterfaces.freezer_serialnmb[i] = null;
      }
      this.freezeForm = tableInterfaces.freezer_serialnmb;
      this.freezeForm.freezer_code = this.freezer_code;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          // console.log(this.freezeForm)
          this.axios
            .put("console/freezer_serialnumber/update", this.freezeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.getSerialNumber(this.theid);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          // console.log(this.freezeForm)
          this.axios
            .post("console/freezer_serialnumber/add", this.freezeForm)
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              // console.log(this.theid)
              this.getSerialNumber(this.theid);
            });
        }
      }
    },
  },
 
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
